import React, { useCallback, useMemo, useState } from "react";
import { ChildrenProps } from "../Models/componentModel";
import {

    AdminDetailsResponse,
    CommonResponseSecondaryModel,
} from "../Models/axiosModel";
import agent from "../service/api";

const AdminDashboardContext = React.createContext<AdminDashboardContextPayload | undefined>(undefined);

export interface AdminDashboardContextPayload {
    adminDashboardDetails: AdminDetailsResponse;
    setAdminDashboardDetails: React.Dispatch<React.SetStateAction<AdminDetailsResponse>>;
    getAdminDashboardDetails: () => Promise<CommonResponseSecondaryModel<AdminDetailsResponse>>;

    adminDashboardGlobalDetails: AdminDetailsResponse;
    setAdminDashboardGlobalDetails: React.Dispatch<React.SetStateAction<AdminDetailsResponse>>;

    adminDashboardFormDetails: any;
    setAdminDashboardFormDetails: React.Dispatch<React.SetStateAction<any>>;

    removeAgentAPI: any

    getSuperAdminDashboardDetailsAPI: any
}

const AdminDashboardProvider = ({ children }: ChildrenProps) => {

    const [adminDashboardDetails, setAdminDashboardDetails] = useState<AdminDetailsResponse>({
        overall: { total_agents: 0, total_profiles: 0, active_agents: 0, pending_requests_count: 0 },
        recentAgentLoginDetails: [],
        profileDetails: []
    });

    const [adminDashboardGlobalDetails, setAdminDashboardGlobalDetails] = useState<AdminDetailsResponse>({
        overall: { total_agents: 0, total_profiles: 0, active_agents: 0, pending_requests_count: 0 },
        recentAgentLoginDetails: [],
        profileDetails: []
    })

    const [adminDashboardFormDetails, setAdminDashboardFormDetails] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone_number: "",
        // re_captcha: "",
    })

    // for admin dashboard
    const getAdminDashboardDetails = useCallback(async () => {
        const response = await agent.getAdminDashboardDetailsAPI.get();
        return response;
    }, []);

    const removeAgentAPI = useCallback(async (agent_id: number) => {
        const response = await agent.removeAgentAPI.delete(agent_id);
        return response;
    }, []);

    // for super admin dashboard 
    const getSuperAdminDashboardDetailsAPI = useCallback(async (startDate: any, endDate: any) => {
        const response = await agent.getSuperAdminDashboardDetailsAPI.get(startDate, endDate);
        return response;
    }, []);

    const payload = useMemo(() => ({
        adminDashboardDetails,
        setAdminDashboardDetails,
        getAdminDashboardDetails,
        adminDashboardGlobalDetails,
        setAdminDashboardGlobalDetails,
        adminDashboardFormDetails,
        setAdminDashboardFormDetails,
        removeAgentAPI,
        getSuperAdminDashboardDetailsAPI
    }), [
        adminDashboardDetails,
        getAdminDashboardDetails,
        adminDashboardGlobalDetails,
        adminDashboardFormDetails,
        removeAgentAPI,
        getSuperAdminDashboardDetailsAPI
    ]);

    return (
        <AdminDashboardContext.Provider value={payload}>{children}</AdminDashboardContext.Provider>
    );
};

export { AdminDashboardContext, AdminDashboardProvider };
